import homeAPI from '@/api/home'
import {getToken, setToken, removeToken,setIsLogin} from '@/utils/auth'
import router, {resetRouter} from '@/router'
import Cookies from 'js-cookie'


const state = {
    token: getToken(),
    account: "",
    email: "",
    id: "",
    mobile: "",
    name: "",
    team_id: null,
    team_name: "",
    username: "",
    is_bind_wx:false,
    is_sub_account:false,
    super_admin:'',
    is_admin:'',
    umc_token:'',
    position:'',
    // isSubAccount
    page_config:{
        default_page: '', //默认页面配置
    },
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_USER_INFO: (state, user) => {
        // console.log('SET_USER_INFO',user);
        // state = Object.assign(state, user);
        state.account = user.account;
        state.email = user.email;
        state.id = user.id;
        state.is_admin = user.is_admin;
        state.mobile = user.mobile;
        state.name = user.name;
        state.super_admin = user.super_admin;
        state.team_id = user.team_id;
        state.team_name = user.team_name;
        state.position = user.position;
    },
    SET_IS_BINK_WX(state, status) {
        state.is_bind_wx = status;
    },
    SET_IS_SUB_ACCOUNT(state, status) {
        state.is_sub_account = status;
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    LOG_OUT(state){
        Cookies.remove('bindWxAction'+state.name);
        state.account = '';
        state.email = '';
        state.id = '';
        state.mobile = '';
        state.name = '';
        state.team_id = '';
        state.team_name = '';
        state.username = '';
        state.is_bind_wx = '';
        state.is_sub_account = '';
        state.super_admin = '';
        state.is_admin = '';
    },
    SET_UMC_TOKEN(state,umcToken){
        umcToken = umcToken||{};
        state.umc_token = umcToken.access_token||'';
    },
    UPDATE_PAGE_CONFIG(state,page_config){
        console.log('UPDATE_PAGE_CONFIG',page_config);
        state.page_config = page_config;
    },
};

const actions = {
    getAUC({commit},reqData){
        return new Promise((resolve, reject) => {
            homeAPI.getAUC(reqData).then(res => {
                const {data} = res;
                setIsLogin(true);
                if(reqData.to_path){
                    window.location.href = reqData.to_path;
                }
                localStorage.setItem("needLoginSuccessModal",'true');
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })

    },
    getUserInfo({commit}) {
        return new Promise((resolve, reject) => {
            homeAPI.getUserInfo().then(res => {
                const {data} = res;
                const {
                    navigation,
                    user,
                    role_id,
                    is_bind_wx,
                    is_sub_account,
                    umc_token,
                    token,
                    user_page_config,
                } = data;
                commit('SET_UMC_TOKEN', umc_token);
                commit('SET_USER_INFO', user);
                commit('SET_IS_BINK_WX', is_bind_wx);
                commit('SET_IS_SUB_ACCOUNT', is_sub_account);
                commit('UPDATE_PAGE_CONFIG', user_page_config);
                Cookies.set('CSRF-TOKEN', token, { path: '/td' });


                // commit('SET_NAVIGATION', navigation);

                // commit('SET_ROLES', roles)
                // commit('SET_NAME', name)
                // commit('SET_AVATAR', avatar)
                // commit('SET_INTRODUCTION', introduction)
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    checkAlive(){
        return new Promise((resolve, reject) =>{
            homeAPI.checkAlive().then((res)=>{
                resolve(true,res)
            }).catch((err)=>{
                reject(false,err)
            })
        })
    },

    // remove token
    resetToken({commit}) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            // commit('SET_ROLES', [])
            removeToken()
            resolve()
        })
    },

    // dynamically modify permissions
    async changeRoles({commit, dispatch}, role) {
        const token = role + '-token'

        commit('SET_TOKEN', token)
        setToken(token)

        const {roles} = await dispatch('getInfo')

        resetRouter()

        // generate accessible routes map based on roles
        const accessRoutes = await dispatch('permission/generateRoutes', roles, {root: true})
        // dynamically add accessible routes
        router.addRoutes(accessRoutes)

        // reset visited views and cached views
        dispatch('tagsView/delAllViews', null, {root: true})
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
